import { render, staticRenderFns } from "./Panes.vue?vue&type=template&id=16b3e9b4&scoped=true&"
import script from "./Panes.vue?vue&type=script&lang=js&"
export * from "./Panes.vue?vue&type=script&lang=js&"
import style0 from "./Panes.vue?vue&type=style&index=0&id=16b3e9b4&scoped=true&lang=css&"
import style1 from "./Panes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b3e9b4",
  null
  
)

export default component.exports